// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iatpFfj3Z5El5ghj{width:100%;height:100%}.iatpFfj3Z5El5ghj .tooltip-columns{display:grid;grid-template-rows:repeat(5, auto);grid-template-columns:repeat(minmax(1fr, auto));column-gap:16px;grid-auto-flow:column}.iatpFfj3Z5El5ghj .tooltip-columns .individual{white-space:nowrap}.iatpFfj3Z5El5ghj .tooltip-footnote{margin-top:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scatterChart": `iatpFfj3Z5El5ghj`
};
export default ___CSS_LOADER_EXPORT___;
